import * as React from 'react';
import Slider from '@mui/material/Slider';


function valuetext(value) {
  return `${value}%`;
}

export default function DiscreteSlider({ onChange, value }) {
  return (
    <Slider
      onChange={onChange}
      getAriaValueText={valuetext}
      valueLabelFormat={valuetext}
      valueLabelDisplay="auto"
      value={value}
      min={0}
      max={100}
      sx={{
        color: 'rgb(14 165 233)',
        height: 6,
        '& .MuiSlider-rail': { opacity: 0.25 },
        '& .MuiSlider-thumb': {
          width: 20,
          height: 20,
          backgroundColor: '#fff',
          border: '3px solid currentColor',
          '&:hover, &.Mui-focusVisible': { boxShadow: '0 0 0 8px rgb(14 165 233 / 0.16)' },
        },
      }}
    />
  );
}
